import './FilterBar.scss';

export default function FilterBar({ children, className = '', flat = false }) {
    const classes = [
        'ui-filter-bar',
        flat && 'ui-filter-bar--flat',
        className,
    ].filter(Boolean).join(' ');

    return <div className={classes}>{children}</div>;
}

export function FilterBarActions({ children, className = '' }) {
    return (
        <div className={`ui-filter-bar__actions ${className}`.trim()}>
            {children}
        </div>
    );
}
